
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import config from '@/config'
import { getNewslist } from '@/api/youzheng'
export default {
name: 'service-bmfw',
components: {
Flexbox,
FlexboxItem
},
data () {
return {
baseUrl: config.baseUrl,
menulist: []
}
},
created () {
this.getBianmin()
},
methods: {
goto (href) {
window.location.href = href
},
getBianmin () {
getNewslist({
pageCurrent: 1,
pageSize: 1000,
CATEGORYCODE: 'cat01_02',
owner_type: config.owner_type,
searchValue: ''
}).then(data => {
data.obj.forEach((item, i) => {
this.menulist.push({
imgurl: config.baseUrl + item.pcTitleImgURL,
title: item.TITLE,
href: item.MOBILE_LINK
})
})
})
}
}
}
